/**
 * Distillery select dropdown component
 */

import { forwardRef } from 'react';
import { Select } from '../common';
import { useAllDistilleries } from '../../hooks/useDistilleries';

/**
 * Dropdown for selecting a distillery
 * @param {Object} props - Component props
 * @param {string} props.label - Label text
 * @param {string} props.error - Error message
 * @returns {React.ReactElement} Select element
 */
const DistillerySelect = forwardRef(function DistillerySelect({
  label = 'Distillery',
  error,
  ...props
}, ref) {
  const { data: distilleries = [], isLoading } = useAllDistilleries();

  const options = distilleries.map(d => ({
    value: d.id,
    label: `${d.distillery_name} (${d.country})`
  }));

  return (
    <Select
      ref={ref}
      label={label}
      placeholder={isLoading ? 'Loading...' : 'Select a distillery'}
      options={options}
      error={error}
      disabled={isLoading}
      {...props}
    />
  );
});

export default DistillerySelect;
